import type { ReactNode } from "react";
import type { Post } from "scantling-common";
import { DateDisplay, PhaseChip, CountdownDisplay } from "./components.js";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";
import { Separator } from "@/components/ui/separator";

interface PostHoverCardProps {
  post: Post;
  children: ReactNode;
}

export function PostHoverCard({ post, children }: PostHoverCardProps) {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent className="w-72" align="start">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm font-medium">{post.slug}</span>
            <PhaseChip phase={post.phase} />
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>{post.channelSlug}</span>
            <span>·</span>
            <span>v{post.itemVersion}</span>
          </div>
          <Separator />
          <div className="flex flex-col gap-1.5 text-xs">
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Item</span>
              <span className="font-mono">{post.itemSlug}</span>
            </div>
            {post.scheduledAt && (
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Scheduled</span>
                <CountdownDisplay value={post.scheduledAt} />
              </div>
            )}
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Created</span>
              <DateDisplay value={post.createdAt} />
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
